import React, { useId } from "react";
import ModalBlank from "./modals/ModalBlank";

interface VideoEmbedModalProps {
  isOpen: boolean;
  onClose: () => void;
  videoUrl: string;
}

const VideoEmbedModal: React.FC<VideoEmbedModalProps> = ({
  isOpen,
  onClose,
  videoUrl,
}) => {
  const modalId = useId();

  // Function to extract video ID from YouTube or Vimeo URL
  const getEmbedUrl = (url: string): string => {
    // YouTube URL patterns
    const youtubeRegex =
      /(?:youtube\.com\/(?:[^\/]+\/.+\/|(?:v|e(?:mbed)?)\/|.*[?&]v=)|youtu\.be\/)([^"&?\/\s]{11})/i;
    const youtubeMatch = url.match(youtubeRegex);

    if (youtubeMatch && youtubeMatch[1]) {
      return `https://www.youtube.com/embed/${youtubeMatch[1]}?autoplay=1`;
    }

    // Vimeo URL patterns
    const vimeoRegex =
      /(?:vimeo\.com\/(?:video\/)?|player\.vimeo\.com\/video\/)([0-9]+)/i;
    const vimeoMatch = url.match(vimeoRegex);

    if (vimeoMatch && vimeoMatch[1]) {
      return `https://player.vimeo.com/video/${vimeoMatch[1]}?autoplay=1`;
    }

    // If no match, return the original URL
    return url;
  };

  const embedUrl = getEmbedUrl(videoUrl);

  return (
    <ModalBlank
      id={modalId}
      modalOpen={isOpen}
      setModalOpen={onClose}
      showCloseButton
      className="max-w-6xl"
      closeOnOutClick
    >
      <div className="p-1 sm:p-2 w-full max-w-6xl mx-auto">
        <div className="relative pb-[56.25%] h-0 overflow-hidden">
          <iframe
            className="absolute top-0 left-0 w-full h-full"
            src={embedUrl}
            title="Video Player"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          ></iframe>
        </div>
      </div>
    </ModalBlank>
  );
};

export default VideoEmbedModal;
